// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "GothamBold";
  src: url("/fonts/gothambold_normal_normal.woff2") format("woff2");
  font-weight: 1rem;
  font-style: 1rem;
}
@font-face {
  font-family: "GothamNarrowBook";
  src: url("/fonts/GothamNarrowBook_normal_condensed.woff2") format("woff2");
  font-weight: 1rem;
  font-style: 1rem;
}
.cvx-font-gotham-bold, aside .cvx-aside-left-title, aside ::ng-deep .p-tree-empty-message {
  font-family: "GothamBold", Arial, sans-serif;
}

.cvx-fon-narrow-bold {
  font-family: "GothamNarrowBold", Arial, sans-serif;
}

.cvx-font-gotham-narrow-book {
  font-family: "GothamNarrowBook", Arial, sans-serif;
}

.cvx-gothan-medium {
  font-family: "GothamMedium", Arial, sans-serif;
}

/*font-szes*/
.extraLarge {
  font-size: 1.75rem;
  /*28px*/
}

.large2 {
  font-size: 1.375rem;
  /*22px*/
}

.large {
  font-size: 1.125rem;
  /*18px*/
}

.normal {
  font-size: 1rem;
  /*16px*/
}

.medium {
  font-size: 0.875rem;
  /*14px*/
}

.small {
  font-size: 0.75rem;
  /*12px*/
}

aside {
  display: grid;
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  grid-template-columns: 100%;
  grid-template-rows: 40px 1fr;
  grid-template-areas: "aside-left-title" "aside-left-content";
  align-items: center;
  justify-items: center;
}
aside .cvx-aside-left-title {
  grid-area: aside-left-title;
  font-size: 20px;
  color: #0b2d71;
}
aside .cvx-aside-left-content {
  display: flex;
  grid-area: aside-left-content;
  overflow: auto;
  width: 100%;
  height: 100%;
}
aside ::ng-deep .p-tree-empty-message {
  color: #0b2d71;
  text-align: center;
}
aside ::ng-deep ul, aside ol {
  font-size: 14px;
  padding-left: 10px;
}
aside .left-content {
  width: 100%;
}
aside p-tree {
  width: 100%;
  height: 100%;
}
aside .spinner {
  display: flex;
  justify-content: center;
  width: 100%;
}

::ng-deep app-root {
  transition: 700ms;
}
::ng-deep app-root:has(* .cvx-no-transition) {
  transition: none !important;
}
::ng-deep app-root:has(app-cvx-aside-left aside.cvx-slide-panel.cvx-hidden-content) {
  grid-template-columns: 0px 1fr;
}
::ng-deep app-root:has(app-cvx-aside-left aside.cvx-slide-panel) {
  --left: 330px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
